import { PdfPageWrapper } from "../../../forms/pdf-components/PdfPageWrapper";
import { PdfPatientHeaderRow } from "./sections/PdfPatientHeaderRow";
import { PdfNotificationOfService } from "./sections/PdfNotificationOfService";
import { PdfPharmacyUseOnly } from "./sections/PdfPharmacyUseOnly";

/**
 * PdfPage3
 *
 * Sections:
 *   1. Compact Patient Name + Health Card row
 *   2. Notification of Service
 *   3. Pharmacy Use Only
 */
export const PdfPage3 = ({
  pharmacyProps,
  serviceDate,
  patient,
  documentation,
}) => (
  <PdfPageWrapper pharmacyProps={pharmacyProps}>
    <PdfPatientHeaderRow patient={patient} />

    <PdfNotificationOfService documentation={documentation} />

    <PdfPharmacyUseOnly />
  </PdfPageWrapper>
);
